/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetGroupsForResourceQuery,
  GroupsForResourceSortInput,
  GroupsForResourceFilterInput,
} from "~/generated/graphql";
import { showError } from "~/services/toast";

type Props = {
  resourceId: string;
  page: string;
  limit: string;
  sort?: GroupsForResourceSortInput;
  filter?: GroupsForResourceFilterInput;
  skip?: boolean;
};

export function useGetGroupsForResource({
  resourceId,
  page,
  limit,
  sort,
  filter,
  skip,
}: Props) {
  const {
    data: result,
    loading,
    error,
    refetch,
  } = useGetGroupsForResourceQuery({
    variables: {
      resourceId,
      page: Number(page),
      limit: Number(limit),
      sort: sort,
      filter: filter,
    },
    onError(err) {
      showError(err.message);
    },
    skip,
  });

  const data = result?.groupsForResource?.result ?? [];
  const count = result?.groupsForResource.pageInfo.count ?? 0;

  return { data, loading, count, error, refetch } as const;
}
